import { Button } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { LuPlusCircle } from "react-icons/lu";
import NoDataFound from "../../components/NoDataFound";
import LoadingGif from "../../assets/loading_anim.gif";
import DeleteIcon from "../../assets/CloseOrDelete.svg";
import CylinderTypeModal from "../../modal/CylinderTypeModal";
import toast from "react-hot-toast";
import {
  deleteServices,
  getServices,
  postServices,
} from "../../apiServices/apiServices";

function ManageCylinderType() {
  const [isModalOpen, setIsModalOpen] = useState({
    add_cylinder: false,
    update_cylinder: false,
  });
  const [loading, setLoading] = useState({ screen: false, btn: false });
  const [cylinderList, setCylinderList] = useState([]);
  const [fieldData, setFieldData] = useState({
    cylinder_type: "",
  });

  useEffect(() => {
    fetchCylinderTypeData(true);
  }, []);

  const fetchCylinderTypeData = async (load_bool) => {
    setLoading({ ...loading, screen: load_bool });
    try {
      const res = await getServices(`/api/list/cylindertype`);
      setLoading({ ...loading, screen: false });
      if (res.responseCode === 200) {
        setCylinderList(res.responseData);
      } else {
        setCylinderList([]);
      }
    } catch (error) {
      setLoading({ ...loading, screen: false });
      toast.error(error);
    }
  };

  const handleopenAddModal = () => {
    setIsModalOpen({ ...isModalOpen, add_cylinder: true });
    setFieldData({
      ...fieldData,
      cylinder_type: "",
    });
  };

  // const handleOpenUpdateModal = (cylinder_data) => {
  //   setIsModalOpen({ ...isModalOpen, update_cylinder: true });
  //   setFieldData({
  //     ...fieldData,
  //     cylinder_type: "35",
  //   });
  // };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    try {
      const res = await postServices(`/api/add/cylindertype`, {
        cylinder_type: fieldData.cylinder_type,
      });
      setLoading({ ...loading, btn: false });
      if (res.responseCode === 200) {
        setIsModalOpen({ ...isModalOpen, add_cylinder: false });
        toast.success("New Cylinder Type added...");
        fetchCylinderTypeData(false);
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
      setLoading({ ...loading, btn: false });
    }
  };

  // const handleUpdateSubmit = async (e) => {
  //   e.preventDefault();
  // };

  const handleDeleteCylinder = async (cylinder_data) => {
    if (window.confirm("Do you want to delete this cylinder?")) {
      try {
        const res = await deleteServices(
          `/api/delete/cylindertype?cylinder_type_id=${cylinder_data._id}`
        );
        if (res.responseCode === 200) {
          fetchCylinderTypeData(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  return (
    <>
      <div className="p-6">
        <div className="flex flex-col md:flex-row justify-between items-center relative mt-5">
          <h1 className="text-[#19161F] text-4xl font-bold">Cylinders</h1>
          <Button
            onClick={handleopenAddModal}
            className="mt-4 md:mt-0 font-poppins bg-[#BD3B24] font-medium text-xs sm:text-sm xl:text-base rounded-xl flex items-center gap-2 px-4 sm:px-6 ml-auto outline-none"
          >
            <LuPlusCircle />
            Add
          </Button>
        </div>

        {!loading.screen ? (
          <div>
            {cylinderList.length > 0 ? (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 pt-5 gap-4">
                {cylinderList.map((cylinder, i) => (
                  <div key={i} className="bg-white p-4 shadow-xl rounded-xl">
                    <div className="flex justify-end items-center gap-3">
                      {/* <LuPencil
                        className="font-bold text-lg text-[#03438D] cursor-pointer"
                        onClick={() => handleOpenUpdateModal(cylinder)}
                      /> */}
                      <img
                        src={DeleteIcon}
                        alt=""
                        className="cursor-pointer"
                        onClick={() => handleDeleteCylinder(cylinder)}
                      />
                    </div>
                    <p className="text-sm break-all pt-2">
                      {cylinder.cylinder_type?.toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <NoDataFound />
            )}
          </div>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>

      <CylinderTypeModal
        open={isModalOpen.add_cylinder}
        onClose={() => setIsModalOpen({ ...isModalOpen, add_cylinder: false })}
        loading={loading}
        modal={isModalOpen}
        fieldData={fieldData}
        setFieldData={setFieldData}
        handleAddSubmit={handleAddSubmit}
      />
      {/* <CylinderTypeModal
        open={isModalOpen.update_cylinder}
        onClose={() =>
          setIsModalOpen({ ...isModalOpen, update_cylinder: false })
        }
        loading={loading}
        modal={isModalOpen}
        fieldData={fieldData}
        setFieldData={setFieldData}
        handleUpdateSubmit={handleUpdateSubmit}
      /> */}
    </>
  );
}

export default ManageCylinderType;
